import React from 'react';
import {Switch, Route, BrowserRouter, Redirect} from 'react-router-dom';

import HomePage from "./HomePage/index";

import CategoryPage from './Category/index';
import Progress from './Progress/index-new';
import Extras from './Extras/index';
import Register from './Register/index';
import Login from './Login/index';
import Questions from './Questions/index';
import ExtraItemPage from './Extras/extra-item-page';
import AssessmentComplete from "./AssessmentComplete";
import ForgotPassword from './ForgotPassword';
import Profile from './Profile';
import Purchase from "./Purchase";
import {TourProvider} from "../contexts/TourContext";
import ResetPassword from "./ResetPassword";


export default function App() {
    return (
        <BrowserRouter>
            <Switch>
                <TourProvider>

                    <Route exact path="/welcome" component={HomePage}/>
                    <Route exact path="/profile" component={Profile} />
                    <Route path="/section/:category" render={(props) => (
                        <CategoryPage key={props.match.params.category} {...props} />)
                    }/>
                    <Route exact path="/progress/" component={Progress}/>
                    <Route exact path="/extras/" component={Extras}/>
                    <Route exact path="/extras/:slug/" component={ExtraItemPage}/>
                    <Route exact path="/register/:lk?" component={Register}/>
                    <Route exact path="/reset/:token" component={ResetPassword}/>
                    <Route exact path="/purchase/" component={Purchase}/>
                    <Route exact path="/login/" component={Login}/>
                    <Route exact path="/" component={Login}/>
                    <Route exact path="/questions/" component={Questions}/>
                    <Route exact path="/assessment-complete/" component={AssessmentComplete}/>
                    <Route exact path="/forgot-password/" component={ForgotPassword}/>


                    {/* <Route render={() => <Redirect to={{pathname: "/progress"}} />} /> */}
                </TourProvider>
            </Switch>
        </BrowserRouter>
    );
}

